/** Generated by swagger-axios-codegen */
// korekty:
// 1) CONFIG.baseURL
// 2) dodanie brakujących inicjacji pól zależnie od typów

import axiosStatic, { AxiosPromise, AxiosInstance } from 'axios';
import CONFIG from '../cfg/config';
const qs = require('qs');

let serverUrl = () => {
  return CONFIG.apiURL;
}


let vscXyzUrl = () => {
  return "https://vsc24.net/vscXyz";
}

export interface IRequestOptions {
  headers?: any;
}

interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
  timeout?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
function axios(configs: IRequestConfig): AxiosPromise {
  return serviceOptions.axios ? serviceOptions.axios.request(configs) : axiosStatic(configs);
}

export class portalService {
  /**
   * Zapoczatkowanie sesji
   */
  static openSession(
    params: {
      /**  */
      instanceId: string;
      /**  */
      hotelId: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/session';

      configs.url = url;
      configs.params = { instanceId: params['instanceId'], hotelId: params['hotelId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class userService {
  static getUserInfo(
    params: {
      /**  */
      hotelId: string;
      aId: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<User>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajOperatorzy0';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aId: params['aId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
export class hotelService {
  /**
   * Podstawowe informacje na stronę
   */
  static getHotelInfo(
    params: {
      hotelId: string;
      lang?: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webHotel> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        // nie - to serwer ma ustawić:       'Access-Control-Allow-Origin': '*', // cors
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/info';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], lang: params['lang'] };
      let data = null;
      configs.data = data;
      axios(configs)
        .then(res => {
          /* test:  
                    alert(url);
                    alert('dane odebrane ='+JSON.stringify(res.data))
                    alert(res.status);
                    alert(res.statusText);
                    alert(res.headers);
                    alert(res.config);
           */
          resolve(res.data);
        })
        .catch(err => {
          //alert('Bad config?');
          //          alert('error:'+JSON.stringify(err))
          reject(err);
        });
    });
  }
  /**
   * Kontakt
   */
  static getHotelContact(
    params: {
      /**  */
      hotelId: string;
      lang?: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webContact> {
    return new Promise((resolve, reject) => {
      //const configs: IRequestConfig = { ...options, timeout: 5000, method: 'get' };
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/contact';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], lang: params['lang'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  static dajSerwerWersja(
    params: {
      /**  */
      hotelId: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<{result: string}> {
    return new Promise((resolve, reject) => {
      //const configs: IRequestConfig = { ...options, timeout: 5000, method: 'get' };
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajSerwerWersja';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

//   static getPortalInfo(
//     params: {
//       hotelId: string;
//       operatorId: number;
//       domena?: string;
//     } = <any>{},
//     options: IRequestOptions = {}
//   ): Promise<Result<WwwPortalInfo0>> {
//     return new Promise((resolve, reject) => {
//       const configs: IRequestConfig = { ...options, method: 'get' };
//       configs.headers = {
//         ...options.headers,
//         'Content-Type': 'application/json'
//       };

//       let url = serverUrl() + '/manager/recepcjaDajWwwPortalInfo0';
//       configs.url = url;
//       configs.params = { hotelId: params['hotelId'], operatorId: params['operatorId'], domena: params['domena'] };
//       let data = null;
//       configs.data = data;

//       axios(configs)
//         .then(res => {
//           resolve(res.data);
//         })
//         .catch(err => {
//           reject(err);
//         });
//     });
//   }
 }

export class roomsService {
  /**
   * Dane pobierane z recepcja_dajWwwRodzajePokoi_Info + uzupełniane na stronie web...
   */
  // static getRooms(
  //   params: {
  //     hotelId: string;
  //     lang?: string;
  //   } = <any>{},
  //   options: IRequestOptions = {}
  // ): Promise<webRooms> {
  //   return new Promise((resolve, reject) => {
  //     const configs: IRequestConfig = { ...options, method: 'get' };
  //     configs.headers = {
  //       ...options.headers,
  //       'Content-Type': 'application/json'
  //     };
  //     let url = serverUrl() + '/portal/rooms';

  //     configs.url = url;
  //     configs.params = { hotelId: params['hotelId'], lang: params['lang'] };
  //     let data = null;

  //     configs.data = data;
  //     axios(configs)
  //       .then(res => {
  //         resolve(res.data);
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   });
  // }

  static getRooms(
    params: {
      hotelId: string;
      aOperatorId: number;
      aDomena: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<webRoom>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwRodzajePokoiInfo1';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aDomena: params['aDomena'],
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getRooms2(
    params: {
      hotelId: string;
      aOperatorId: number;
      aDomena: string;
      aDataOd: string;
      aDataDo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<webRoom>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwRodzajePokoiInfo2';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aDomena: params['aDomena'],
        aDataOd: params['aDataOd'],
        aDataDo: params['aDataDo'],
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getRoomsSubpage(
    params: {
      hotelId: string;
      aOperatorId: number;
      aDomena: string;
      aPodstronaNr: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<webRoom>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwRodzajePokoiInfoPodstrona1';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aDomena: params['aDomena'],
        aPodstronaNr: params['aPodstronaNr'],
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getRoomsSubpage2(
    params: {
      hotelId: string;
      aOperatorId: number;
      aDomena: string;
      aPodstronaNr: number;
      aDataOd: string;
      aDataDo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<webRoom>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwRodzajePokoiInfoPodstrona2';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aDomena: params['aDomena'],
        aPodstronaNr: params['aPodstronaNr'],
        aDataOd: params['aDataOd'],
        aDataDo: params['aDataDo'],
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * galeria zdjęć
   */
  static getGallery(
    params: {
      /**  */
      hotelId: string;
      /**  */
      rodzPokoi: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webRoomGallery> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/hotel/image/galeria';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], rodzPokoi: params['rodzPokoi'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * dostępność
   */
  static getDetails(
    params: {
      hotelId: string;
      lang?: string;
      roomCategory: string;
      dateFrom: string;
      dateTo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webRoomDetails> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/details';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        lang: params['lang'],
        roomCategory: params['roomCategory'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo']
      };
      let data = null;

      configs.data = data;
      //alert('wysyłam: '+JSON.stringify(configs))      
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getCalendar(
    params: {
      /**  */
      hotelId: string;
      /**  */
      lang?: string;
      /**  */
      dateFrom: string;
      /**  */
      dateTo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webCalendar> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/calendar';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        lang: params['lang'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class grafikOgolny {
  /**
   * Dane pobierane z recepcja_dajWwwRodzajePokoi_Info + uzupełniane na stronie web...
   */
  static getRooms(
    params: {
      hotelId: string;
      aOperatorId: number;
      aManagerOK: number;
      aDataOd: string;
      aDataDo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<grafik> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwGrafikOgolnyTresc0';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aManagerOK: params['aManagerOK'],
        aDataOd: params['aDataOd'], aDataDo: params['aDataDo']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getRoomsSubpage(
    params: {
      hotelId: string;
      aOperatorId: number;
      aManagerOK: number;
      aDataOd: string;
      aDataDo: string;
      aPodstronaNr: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<grafikOgolnyPokoje>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwGrafikOgolnyTrescPodstrona0';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aManagerOK: params['aManagerOK'],
        aDataOd: params['aDataOd'], aDataDo: params['aDataDo'], aPodstronaNr: params['aPodstronaNr']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class pokojeNazwa {
  /**
   * Dane pobierane z recepcja_dajWwwRodzajePokoi_Info + uzupełniane na stronie web...
   */
  static getRoomsName(
    params: {
      hotelId: string;
      aOperatorId: number;
      domena: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<RoomsNames> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwGrafikOgolnyWiersze0';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], domena: params['domena'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
export class bookService {
  /**
   * Dodanie nowej rezerwacji
   */
  static reservNew(
    params: {
      /** Rezeracja pokoi */
      hotelId: string,
      aOperatorId: number,
      body: Rezerwacja;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<ReservationId> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaPobytDodaj0';
      configs.url = url;
      let data = [{ ...params['body'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aJSON: JSON.stringify(data) };
      //console.log( configs)
      configs.data = null;
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      setTimeout(function () {
      }, 300);
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  /**
   * Zmiana rezerwacji
   */
  static pobytZmien(
    params: {
      /** Rezeracja pokoi */
      hotelId: string,
      aOperatorId: number,
      aPobytId: number,
      body: Rezerwacja;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<ReservationId> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaPobytZmien';
      configs.url = url;
      let data = [{ ...params['body'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aPobytId: params['aPobytId'], aJSON: JSON.stringify(data) };
      //console.log( configs)
      configs.data = null;
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      setTimeout(function () {
      }, 300);
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  /**
   * Pobranie wolnych pokoi danego rodzaju
   */
  static dajDostepnosc(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRodzPokoiId: number,
      aDataOd: string,
      aDataDo: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Dostepnosc> {                        ////////////////////Dostepnosc
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwPokojeDostepnosc1';
      configs.url = url;
      //console.log(configs);
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aRodzPokoiId: params['aRodzPokoiId'],
        aDataOd: params['aDataOd'],
        aDataDo: params['aDataDo']
      };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static dajCeny(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRodzPokoiId: number,
      aDataOd: string,
      aDataDo: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Dostepnosc> {                        
  //): Promise<Result<Ceny>> {                        
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwPokojeCeny2';
      configs.url = url;
      //console.log(configs);
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aRodzPokoiId: params['aRodzPokoiId'],
        aDataOd: params['aDataOd'],
        aDataDo: params['aDataDo']
      };
      configs.data = null;
      
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static dajCenyPodstrona(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRodzPokoiId: number,
      aPodstronaNr: number,
      aDataOd: string,
      aDataDo: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Dostepnosc> {                        
  //): Promise<Result<Ceny>> {                        
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwPokojeCenyPodstrona2';
      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aRodzPokoiId: params['aRodzPokoiId'],
        aPodstronaNr: params['aPodstronaNr'],
        aDataOd: params['aDataOd'],
        aDataDo: params['aDataDo']
      };
      configs.data = null;
      
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  /**
   * Zwrócenie wolnych pokoi dla podanego pobytId, rodzaju i dat
   */
  static dajWolnePokoje(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number,
      aRodzPokoi: string,
      aDataOd: string,
      aDataDo: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Dostepnosc> {                        ////////////////////Dostepnosc
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwPokojeWolne';
      configs.url = url;
      //console.log(configs);
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aPobytId: params['aPobytId'],
        aRodzPokoi: params['aRodzPokoi'],
        aDataOd: params['aDataOd'],
        aDataDo: params['aDataDo']
      };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static dajOpcje(
    params: {
      hotelId: string,
      aOperatorId: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<PokojOpcje> {                        ////////////////////Dostepnosc
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = serverUrl() + '/vscServiceFaktura/recepcjaDajWwwTagUwagi';
      //let url = 'http://test.vsc24.eu:8080' + '/vscHotelManager/manager/recepcjaDajWwwTagUwagi';
      let url = serverUrl() + '/manager/recepcjaDajWwwTagUwagi';
      configs.url = url;
      //console.log(url);
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
      };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }


  static reservConfirm(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<ReservationId> {     ////                   
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      let url = serverUrl() + '/manager/recepcjaPobytPotwierdz';
      configs.url = url;

      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aPobytId: params['aPobytId'],
      };
      configs.data = null;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static reservCancel(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<ReservationId> {     ////                   
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      let url = serverUrl() + '/manager/recepcjaPobytAnuluj';
      configs.url = url;

      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aPobytId: params['aPobytId'],
      };
      configs.data = null;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static reservGet(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number,
      aDomena: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<RezerwacjaPobyt>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      let url = serverUrl() + '/manager/recepcjaDajPobyt';
      configs.url = url;

      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aPobytId: params['aPobytId'],
        aDomena: params['aDomena'],
      };
      configs.data = null;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  /**
   * Pobranie danych lienta za pomocą numeru telefonu
   */
  static dajGosc(
    params: {
      hotelId: string,
      aOperatorId: number,
      aTelefon: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<Gosc>> {                        ////////////////////Dostepnosc
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajGoscDlaTelefon';
      configs.url = url;
      //console.log(configs);
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aTelefon: params['aTelefon']
      };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static dajHasla(
    params: {
      param0: dajHaslaType;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<HasłoRezerwacja>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      };

      let url = serverUrl() + '/rezerwacje/dajHasla';

      configs.url = url;

      let data = { ...params['param0'] };

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class infoZalogaService {

  static setPokojStan(
    params: {
      hotelId: string;
      aOperatorId: number;
      aPokojNr: number;
      aPokojStan: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<StanId> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/infoZaloga/ustawPokojStan0';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aPokojNr: params['aPokojNr'],
        aPokojStan: params['aPokojStan']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getPokojeDzien(
    params: {
      hotelId: string;
      aOperatorId: number;
      aData: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<PokojDzien>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/infoZaloga/dajPokojeRuchDzienNPok0';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aData: params['aData']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getPokojeDni(
    params: {
      hotelId: string;
      aOperatorId: number;
      aDataOd: string;
      aDataDo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<pokojeDni> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/infoZaloga/dajPokojeRuchDniNPok0';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aDataOd: params['aDataOd'],
        aDataDo: params['aDataDo']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getPosilkiDzien(
    params: {
      hotelId: string;
      aOperatorId: number;
      aData: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<posilkiDzien> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/infoZaloga/dajPosilkiDzienNPok0';

      configs.url = url;
      //console.log(configs)
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aData: params['aData'],
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getPosilkiDni(
    params: {
      hotelId: string;
      aOperatorId: number;
      aDataOd: string;
      aDataDo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<posilkiDni> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/infoZaloga/dajPosilkiDniNPok0';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aDataOd: params['aDataOd'],
        aDataDo: params['aDataDo']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getPokojeStan(
    params: {
      hotelId: string;
      aOperatorId: number;
      aPokojNrOd: number;
      aPokojNrDo: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<pokojeStany> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/infoZaloga/dajPokojeStanNrOdDoNPok0';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aPokojNrOd: params['aPokojNrOd'],
        aPokojNrDo: params['aPokojNrDo']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getPobyt(
    params: {
      hotelId: string;
      aOperatorId: number;
      aPobytId: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Pobyty> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/infoZaloga/dajPobyt1NPok0';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aPobytId: params['aPobytId']
      };
      let data = null;
      //console.log(configs)
      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static sendToken(
    params: {
      hotelId: string;
      mobileNr: string;
      token: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };
      let url = 'http://test.vsc24.eu:8080/vscSms/fcm/tokenDodaj';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static deleteToken(
    params: {
      hotelId: string;
      mobileNr: string;
      token?: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };
      let url = 'http://test.vsc24.eu:8080/vscSms/fcm/tokenKasuj';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

let nipServerUrl = () => {
  return 'https://vsc24.net/vscSms';
}
export class nipService {

  static dajDanePoNip(
    params: {
      nip: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<DaneNIPGus> { //Promise<Result<DaneNIPGus>>
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = nipServerUrl() + '/gus/dajDanePoNip/' + params['nip'];

      configs.url = url;
      configs.params = {}; //        nip: params['nip'],
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static dajDanePoVies(
    params: {
      kod: string;
      vat: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<DaneNIPVies> { //Result<DaneNIPVies>
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = nipServerUrl() + '/gus/dajDanePoVies/' + params['kod'] + '/' + params['vat'];

      configs.url = url;
      configs.params = {}; // kod: params['kod'], vat: params['vat'],
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static dodajKontrahentDlaPobyt(
    params: {
      hotelId: string;
      adres: string;
      kontrNazwa: string;
      nip: string;
      pobytId: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      };

      let url = serverUrl() + '/faktura/dodajKontrahentDlaPobyt';

      configs.url = url;

      let data = JSON.stringify({ 
        hotelId: params['hotelId'],
        adres: params['adres'],
        kontrNazwa: params['kontrNazwa'],
        nip: params['nip'],
        pobytId: params['pobytId']
      });

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}

export class FcmNotification {
  static sendErrorLog(
    params: {
      hotelId: string;
      aplikacjaId: string;
      mobileNr: string;
      tekst: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };

      //let url = 'http://test.vsc24.eu:8080/vscSms/fcm/fcmAplikacjaWyslij';
      let url = 'https://vsc24.net/vscSms/fcm/fcmAplikacjaWyslij';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], aplikacjaId: params['aplikacjaId'], mobileNr: params['mobileNr'], tekst: params['tekst'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  static sendNotification(
    params: {
      hotelId: string;
      mobileNr: string;
      tekst: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/fcm/fcmWyslij';
      let url = 'https://vsc24.net/vscSms/fcm/fcmWyslij';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], tekst: params['tekst'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static sendToken(
    params: {
      hotelId: string;
      mobileNr: string;
      token: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/fcm/tokenDodaj';
      let url = 'https://vsc24.net/vscSms/fcm/tokenDodaj';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static deleteToken(
    params: {
      hotelId: string;
      mobileNr: string;
      token?: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/fcm/tokenKasuj';
      let url = 'https://vsc24.net/vscSms/fcm/tokenKasuj';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class payService {
  /**
   * wywołanie statusu płatności cashBill na serwerze, 
   * wynikiem jest status płatności
   */
  static getStatus(
    params: {
      /**  */
      hotelId: string,
      idPlatnosci: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<payStatus> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/pay/payCashBillStatus';
      let url = 'https://vsc24.net/vscSms/pay/payCashBillStatus';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], idPlatnosci: params['idPlatnosci'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * wywołanie testu kanałow płatności cashBill ze serwera
   */
  static triggerTest(
    params: {
      /**  */
      hotelId: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<payTest1[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/pay/payCashBillTest';
      let url = 'https://vsc24.net/vscSms/pay/payCashBillTest';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * wywołanie płatności cashBill na serwerze, 
   * wynikiem link do strony z płatnościami
   */
  static getPaymentUrl(
    params: {
      /**  */
      hotelId: string,
      dokNr: string,
      kwota: string,
      opis: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<vscPayment> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/pay/payCashBillZaplac';
      let url = 'https://vsc24.net/vscSms/pay/payCashBillZaplac';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'], kwota: params['kwota'], opis: params['opis'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class payServicePrzelewy24 {
  /**
   * wywołanie statusu płatności Przelewy24 na serwerze, 
   * wynikiem jest status płatności
   */
  // static getStatus(
  //   params: {
  //     /**  */
  //     hotelId: string,
  //     vscNr: string
  //   } = <any>{},
  //   options: IRequestOptions = {}
  // ): Promise<payStatusPrzelewy24> {
  //   return new Promise((resolve, reject) => {
  //     const configs: IRequestConfig = { ...options, method: 'get' };
  //     configs.headers = {
  //       ...options.headers,
  //       'Content-Type': 'application/json'
  //     };
  //     //let url = 'http://test.vsc24.eu:8080/vscSms/pay/payCashBillStatus';
  //     let url = 'https://vsc24.net/vscPay/przelewy24/dajStatus';
  //     configs.url = url;
  //     configs.params = { hotelId: params['hotelId'], vscNr: params['vscNr'] };
  //     let data = null;

  //     configs.data = data;
  //     axios(configs)
  //       .then(res => {
  //         resolve(res.data);
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   });
  // }

  static getStatusPrzelewy24(
    params: {
      /**  */
      hotelId: string,
      vscNr: number,
      prefiks: string,
      kontoId: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Przelewy24Status> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/pay/payCashBillStatus';
      let url = 'https://vsc24.net/vscPay/przelewy24/odczytajStatus';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], vscNr: params['vscNr'], prefiks: params['prefiks'], kontoId: params['kontoId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * wywołanie testu kanałow płatności cashBill ze serwera
   */
  // static triggerTest(
  //   params: {
  //     /**  */
  //     hotelId: string
  //   } = <any>{},
  //   options: IRequestOptions = {}
  // ): Promise<payTest1[]> {
  //   return new Promise((resolve, reject) => {
  //     const configs: IRequestConfig = { ...options, method: 'get' };
  //     configs.headers = {
  //       ...options.headers,
  //       'Content-Type': 'application/json'
  //     };
  //     let url = 'https://vsc24.net/vscSms/pay/payCashBillTest';
  //     configs.url = url;
  //     configs.params = { hotelId: params['hotelId'] };
  //     let data = null;

  //     configs.data = data;
  //     axios(configs)
  //       .then(res => {
  //         resolve(res.data);
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   });
  // }

  /**
   * wywołanie płatności przelewy24 na serwerze, 
   * wynikiem link do strony z płatnościami
   */
  static getPaymentUrl(
    params: {
      /**  */
      hotelId: string,
      vscPreautoryzacja: string,
      vscId: number,
      vscKwota: number,
      vscOpis: string,
      returnUrl: string,
      email: string,
      prefiks: string,
      kontoId: string,
      //okUrl: string,
      //notOkUrl: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<vscPaymentPrzelewy24> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = 'https://vsc24.net/vscPay/przelewy24/zaplac';
      configs.url = url;
      configs.params = { hotelId: params.hotelId, vscId: params.vscId, vscPreautoryzacja: params.vscPreautoryzacja, 
        vscKwota: params.vscKwota, vscOpis: params.vscOpis, returnUrl: params.returnUrl, email: params.email, //okUrl: params.okUrl, notOkUrl: params.notOkUrl 
        prefiks: params.prefiks, kontoId: params.kontoId};
      let data = null;
      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static zaplac2(
    params: {
      aJSON: dajZaplac
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<vscPaymentPrzelewy24> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = serverUrl() + '/konfig/dajIdenty';
      let url = 'https://vsc24.net/vscPay/przelewy24/zaplac2';

      configs.url = url;
      let data = { ...params['aJSON'] };
      //configs.params = data
      configs.data = data;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getConfirmation(
    params: {
      /**  */
      hotelId: string,
      vscId: number,
      vscKwota: number,
      anuluj: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<vscPaymentPrzelewy24> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = 'https://vsc24.net/vscPay/przelewy24/potwierdzenie';
      configs.url = url;
      configs.params = { hotelId: params.hotelId, vscId: params.vscId, vscKwota: params.vscKwota, anuluj: params.anuluj};
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export type dajZaplac = {
  hotelId: string,
  vscPreautoryzacja: string,
  vscId: number,
  vscKwota: number,
  vscOpis: string,
  returnUrl: string,
  email: string,
  kanal: string,
  prefiks: string,
  kontoId: string,

  wsPotwierdzNazwa: string,
  wsPotwierdzParametry: string,
  wsPotwierdzBrakGetPost: string,
  smsBrakWszystkieKoniecError: string,
}

export class reportService {
  /**
   * Otwarcie nowego raportu
   */
  static raportUtargZaCoZrobStandardowy(
    params: {
      hotelId: string,
      aOperatorId: number,
      aDataOdDo: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargZaCoZrobStandardowy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDataOdDo: params['aDataOdDo'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargZaCoDajSumy(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<RaportUtargZaCoSuma>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargZaCoDajSumy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargZaCoDajGrupyAsortymenty(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<RaportUtargZaCoGrupaAsortymenty>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargZaCoDajGrupyAsortymenty';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargZaCoZakoncz(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargZaCoZakoncz';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargJakiOkresyZrobStandardowy(
    params: {
      hotelId: string,
      aOperatorId: number,
      aDataOdDo: number,
      aOkresOd: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiOkresyZrobStandardowy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDataOdDo: params['aDataOdDo'], aOkresOd: params['aOkresOd'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargJakiOkresyDajSumy(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<RaportUtargJakiOkresySuma>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiOkresyDajSumy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargJakiOkresyDajOkresy(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<RaportUtargJakiOkresyOkres>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiOkresyDajOkresy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargJakiOkresyZakoncz(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiOkresyZakoncz';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargJakiSpZaplatyZrobDowolny(
    params: {
      hotelId: string,
      aOperatorId: number,
      aDataOdDo: number,
      aOperIdOd: number,
      aOperIdDo: number,
      aOperatorzy: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiSpZaplatyZrobDowolny';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = {
        hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDataOdDo: params['aDataOdDo'],
        aOperIdOd: params['aOperIdOd'], aOperIdDo: params['aOperIdDo'], aOperatorzy: params['aOperatorzy']
      };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargJakiSpZaplatyDajSumy(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<RaportUtargJakiSpZaplatySuma>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiSpZaplatyDajSumy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargJakiSpZaplatyDajSpZaplaty(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<RaportUtargJakiSpZaplatySpZaplaty>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiSpZaplatyDajSpZaplaty';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }

  static raportUtargJakiSpZaplatyZakoncz(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiSpZaplatyZakoncz';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          alert('Error!!');
          reject(err);
        });
    });
  }
}

export class fotoService {

  /**
   * galeria zdjęć
   */
  static getGallery(
    params: {
      /**  */
      hotelId: string;
      /**  */
      rodzPokoi: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/hotel/image/galeria';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], rodzPokoi: params['rodzPokoi'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  static postFavourite(
    params: {
      hotelId: string;
      rodzPokoi: string;
      kategoria: string;
      nazwaPliku: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/ustawRodzPokoi';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = {
        hotelId: params['hotelId'], rodzPokoi: params['rodzPokoi'],
        kategoria: params['kategoria'], nazwaPliku: params['nazwaPliku']
      }
      //let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })  
      configs.data = data;
      configs.params = data;

      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        });
    });
  }

  static deleteFoto(
    params: {
      hotelId: string;
      rodzPokoi: string;
      kategoria: string;
      nazwaPliku: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/kasujRodzPokoi';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      //let data = { hotelId: params.hotelId, rodzPokoi: params.rodzPokoi, kategoria: params.kategoria, nazwaPliku: params.nazwaPliku }

      //configs.data = data;
      //configs.params = data;
      let fd = new FormData()
      fd.append("hotelId", params['hotelId'])
      fd.append("rodzPokoi", params['rodzPokoi'])
      fd.append("kategoria", params['kategoria'])
      fd.append("nazwaPliku", params['nazwaPliku'])

      configs.data = fd;
      configs.params = fd;


      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        });
    });
  }

  static deleteWspolny(
    params: {
      hotelId: string;
      nazwaPliku: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      };
      let url = serverUrl() + '/hotel/image/kasujWspolne';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = { hotelId: params.hotelId, nazwaPliku: params.nazwaPliku }

      //configs.data = data;
      //configs.params = data;
      let fd = new FormData()

      fd.append("hotelId", params['hotelId'])

      fd.append("nazwaPliku", params['nazwaPliku'])
      configs.data = data;
      configs.params = data;

      console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        });
    });
  }

  static postAddPokojFoto(
    params: {
      hotelId: string;
      rodzPokoi: string;
      fotoGlowne: string;
      kategoria: string;
      plik: any;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': `multipart/form-data; `,
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/dodajRodzPokoi';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      //let data = { hotelId: params['hotelId'], rodzPokoi: params['rodzPokoi'], 
      //  kategoria: params['kategoria'], fotoGlowne: params['fotoGlowne'],  plik: params['plik'] }
      //let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })  
      //configs.data = data;
      //configs.params = data;
      //configs.params = data;

      let fd = new FormData()

      fd.append("hotelId", params['hotelId'])
      fd.append("rodzPokoi", params['rodzPokoi'])
      fd.append("fotoGlowne", params['fotoGlowne'])
      fd.append("kategoria", params['kategoria'])
      fd.append("plik", params['plik'])
      configs.data = fd;
      configs.params = fd;

      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static postAddWspolneFoto(
    params: {
      hotelId: string;
      plik: any;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': `multipart/form-data; `,
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/dodajWspolne';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      //let data = { hotelId: params['hotelId'], plik: params['plik'],}
      //let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })  

      //configs.params = data;
      let fd = new FormData()

      fd.append("hotelId", params['hotelId'])
      fd.append("plik", params['plik'])
      configs.data = fd;
      configs.params = fd;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static postAddStartFoto(
    params: {
      hotelId: string;
      plik: any;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': `multipart/form-data; `,
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/dodajStartowe';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      //let data = { hotelId: params['hotelId'], plik: params['plik'],}
      //let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })  
      //configs.data = data;
      //configs.params = data;
      //configs.params = data;

      let fd = new FormData()

      fd.append("hotelId", params['hotelId'])
      fd.append("plik", params['plik'])
      configs.data = fd;
      configs.params = fd;

      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class obiektService {

  static dajGrafikObiekt(
    params: {
      hotelId: string,
      json: any,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<ObiectRoomRodzaj>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajGrafikObiektPokoje';
      const url = serverUrl() + '/obiekt/dajGrafikObiekt';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, aJSON: JSON.stringify(params.json) };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static dajGrafikObiektPokoje(
    params: {
      hotelId: string,
      json: any,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<ObiectRoomNumer>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajGrafikObiektPokoje';
      const url = serverUrl() + '/obiekt/dajGrafikObiektPokoje';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, aJSON: JSON.stringify(params.json) };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * dane dla dajPokojeDostepne.
   */
  static dajPokojeDostepne(
    params: {
      hotelId: string,
      rodzPokoi: string,
      dataOd: string,
      dataDo: string,
      domena: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<PokojeDostepne>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajPokojeDostepne';
      const url = serverUrl() + '/obiekt/dajPokojeDostepne';

      configs.url = url;

      configs.params = { hotelId: params.hotelId, rodzPokoi: params.rodzPokoi, dataOd: params.dataOd, dataDo: params.dataDo, domena: params.domena, };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * dane dla dajPokojeWolne.
   */
  static dajPokojeWolne(
    params: {
      hotelId: string,
      rodzPokoi: string,
      dataOd: string,
      dataDo: string,
      domena: string,
      pobytId: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<PokojeDostepne>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajPokojeWolne';
      const url = serverUrl() + '/obiekt/dajPokojeWolne';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, rodzPokoi: params.rodzPokoi, dataOd: params.dataOd, dataDo: params.dataDo, domena: params.domena, pobytId: params.pobytId, };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
  * dane dla dajPortalInfo.
  */
  static dajPortalInfo(
    params: {
      hotelId: string,
      domena: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Info> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajPortalInfo';
      const url = serverUrl() + '/obiekt/dajPortalInfo';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, domena: params.domena };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
 * dane dla DajRodzPokoiInfo1.
 */
  static dajRodzPokoiInfo1(
    params: {
      hotelId: string,
      domena: string,
      dataOd: string,
      dataDo: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<RodzPokoiInfo>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajRodzPokoiInfo1';
      const url = serverUrl() + '/obiekt/dajRodzPokoiInfo1';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, domena: params.domena, dataOd: params.dataOd, dataDo: params.dataDo };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * dane dla tagUwagi.
   */
  static dajTagUwagi(
    params: {
      hotelId: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<PokojOpcje> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajTagUwagi';
      const url = serverUrl() + '/obiekt/dajTagUwagi';
      configs.url = url;

      configs.params = { hotelId: params.hotelId };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}

export class telefonService {

  static dajPrefiksy(
    params: {
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<Prefiks>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajGrafikObiekt';
      const url = 'https://vsc24.net/vscSms/sms/dajSmsPrefiksy';
      configs.url = url;

      configs.params = { };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static dajCzarnaListe(
    params: {
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<{tel: string}>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajGrafikObiekt';
      const url = 'https://vsc24.net/vscSms/sms/dajSmsCzarnaListe';
      configs.url = url;

      configs.params = { };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static sprawdzNrTelefonu(
    params: {
      nrTelefonu: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<string>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
    
      //const url = serverUrl() + '/obiekt/dajGrafikObiekt';
      const url = 'https://vsc24.net/vscSms/sms/sprawdzNrTelefonu';
      configs.url = url;

      configs.params = { nrTelefonu: params.nrTelefonu };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}

export class ManagerService {

  static recepcjaSmsPobytPodziekowanie(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      const url = serverUrl() + '/manager/recepcjaSmsPobytPodziekowanie';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, aOperatorId: params.aOperatorId, aPobytId: params.aPobytId, };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static recepcjaSmsPobytPokojGotowy(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      const url = serverUrl() + '/manager/recepcjaSmsPobytPokojGotowy';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, aOperatorId: params.aOperatorId, aPobytId: params.aPobytId, };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static recepcjaSmsPobytPotwierdzenie(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      const url = serverUrl() + '/manager/recepcjaSmsPobytPotwierdzenie';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, aOperatorId: params.aOperatorId, aPobytId: params.aPobytId, };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static recepcjaSmsPobytPrzypomnienie(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      const url = serverUrl() + '/manager/recepcjaSmsPobytPrzypomnienie';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, aOperatorId: params.aOperatorId, aPobytId: params.aPobytId, };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static recepcjaSmsPobytZaliczkiSuma(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/manager/recepcjaSmsPobytZaliczkiSuma';
      const url = serverUrl() + '/manager/recepcjaSmsPobytZaliczkiSuma';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, aOperatorId: params.aOperatorId, aPobytId: params.aPobytId, };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static recepcjaSmsPobytInfo(
    params: {
      hotelId: string,
      aOperatorId: number,
      aPobytId: number,
      aInfo: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      const url = serverUrl() + '/manager/recepcjaSmsPobytInfo';
      configs.url = url;

      configs.params = { hotelId: params.hotelId, aOperatorId: params.aOperatorId, aPobytId: params.aPobytId, aInfo: params.aInfo, };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}

export class SerwisService {
  /**
   * Zapisanie stanu aplikacji do vscSerwis
   */
  static saveReport(
    params: {
      hotelId: string;
      ktoId: string;
      adresIP: string;
      opis: string;
      status: string;
      akcjaNr: string;
      akcjaOpis: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      let url = "https://vsc24.net/vscSerwis/serwis/zapiszRaport"

      configs.url = url;
      configs.params = {
        hotelId: params.hotelId, ktoId: params.ktoId, adresIP: params.adresIP,
        opis: params.opis, status: params.status, akcjaNr: params.akcjaNr, akcjaOpis: params.akcjaOpis
      };
      let data = null;
      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class Oauth2Service {
  static userinfo(
    params: {
      access_token: string;
    } = <any>{},
    options: IRequestOptions = { headers: { Authorization: `Bearer ${params.access_token}` } }
  ): Promise<UserInfo> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };

      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      const url = "https://www.googleapis.com/oauth2/v2/userinfo"

      configs.url = url;

      const data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static me(
    params: {
      access_token: string;
    } = <any>{},
    options: IRequestOptions = { headers: { Authorization: `Bearer ${params.access_token}` } }
  ): Promise<Me> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };

      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      const url = "https://graph.facebook.com/me"

      configs.url = url;
      configs.params = { fields: 'id,name,first_name,last_name,email,picture', access_token: params.access_token };

      const data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class FakturaVatService {

  static getHeader(
    params: {
      hotelId: string;
      dokNr: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatHeder>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/faktura/dajFaktNagl';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getNotes(
    params: {
      hotelId: string;
      dokNr: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatNotes>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + "/faktura/dajFaktNotesKlienta";

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getTableVat(
    params: {
      hotelId: string;
      dokNr: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatTableVat>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/faktura/dajFaktVat';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getTableRows(
    params: {
      hotelId: string;
      dokNr: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatTableRow>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/faktura/dajFaktWiersz';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getInstalacja(
    params: {
      hotelId: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatInstalacja>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/faktura/dajInstalacje';

      configs.url = url;
      configs.params = { hotelId: params['hotelId']};
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getDokNr(
    params: {
      hotelId: string;
      pobytId: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatDokNr>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/faktura/dajPobytFaktDokNr';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], pobytId: params['pobytId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static dajVscDokNr1(
    params: {
      hotelId: string;
      vscPrzydzial: string;
      vscDokNr: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<KsefFaktura>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = serverUrl() + '/faktura/dajFaktNagl';
      let url = "https://vsc24.pl/vscKsef/ksef/dajVscDokNr1";

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], vscPrzydzial: params['vscPrzydzial'], vscDokNr: params['vscDokNr'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class PasscodeService {

  static obiektOtworz(
    params: {
      aJSON: any
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = 'https://vsc24.net/vscHotelSmart/ttlock/obiektOtworz';

      configs.url = url;
      let data = { ...params['aJSON'] };
      //configs.params = data
      configs.data = data;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static pokojOtworz(
    params: {
      aJSON: any
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = 'https://vsc24.net/vscHotelSmart/ttlock/pokojOtworz';

      configs.url = url;
      let data = { ...params['aJSON'] };
      //configs.params = data
      configs.data = data;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static obiektOtworz1(
    params: {
      aJSON: any
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = 'https://vsc24.net/vscHotelSmart/ttlock/obiektOtworz1';

      configs.url = url;
      let data = { ...params['aJSON'] };
      //configs.params = data
      configs.data = data;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static pokojOtworz1(
    params: {
      aJSON: any
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = 'https://vsc24.net/vscHotelSmart/ttlock/pokojOtworz1';

      configs.url = url;
      let data = { ...params['aJSON'] };
      //configs.params = data
      configs.data = data;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static pietroOtworz1(
    params: {
      aJSON: any
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = 'https://vsc24.net/vscHotelSmart/ttlock/pietroOtworz1';

      configs.url = url;
      let data = { ...params['aJSON'] };
      //configs.params = data
      configs.data = data;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static parkingOtworz1(
    params: {
      aJSON: any
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<number>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = 'https://vsc24.net/vscHotelSmart/ttlock/parkingOtworz1';

      configs.url = url;
      let data = { ...params['aJSON'] };
      //configs.params = data
      configs.data = data;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}

export class Result<T> {
  result: T[] = [];

  constructor(data?: any) {
    if (data) {
      this.result = data.result;
    }
  }
}

export class User {

  ident_oper: string = '';


  nazwisko: string = '';


  operator_id: string = '';

  constructor(data?: any) {
    if (data) {
      this['ident_oper'] = data['ident_oper'];
      this['nazwisko'] = data['nazwisko'];
      this['operator_id'] = data['operator_id'];
    }
  }
}

export class webHotel {
  /** recepcja@hotelnowydwor.pl */
  email: string = '';

  /** +48 17 856 09 90 */
  phone: string = '';

  /** +48 17 860 02 17 */
  fax: string = '';

  /** Świlcza 146E 36-072 Świlcza /k. Rzeszowa */
  address: string = '';

  /** 50.067683E, 21.922610N */
  gps: string = '';

  /** tu jest info o hotelu w <FONT Color=#FF0000>
j�zyku polski</FONT>
<FONT Color=#000000><B>
.</B>
<BR>
</FONT>
 */
  panel: string = '';

  constructor(data?: any) {
    if (data) {
      this['email'] = data['email'];
      this['phone'] = data['phone'];
      this['fax'] = data['fax'];
      this['address'] = data['address'];
      this['gps'] = data['gps'];
      this['panel'] = data['panel'];
    }
  }
}

export class webContact {
  /** recepcja@hotelnowydwor.pl */
  email: string = '';

  /** +48 17 856 09 90 */
  phone: string = '';

  constructor(data?: any) {
    if (data) {
      this['email'] = data['email'];
      this['phone'] = data['phone'];
    }
  }
}

export class webRoom {
  /**  */
  cena_brak: number = 0;

  /**  */
  cena_os1: number = 0;

  /**  */
  cena_os2: number = 0;

  /**  */
  cena_os3: number = 0;

  /**  */
  cena_os4: number = 0;

  /**  */
  cena_pokoj: number = 0;

  /**  */
  foto: string = '';

  /**  */
  ilosc_dni_min: number = 0;

  /**  */
  ilosc_miejsc: number = 0;

  /**  */
  info: string = '';

  /**  */
  kolejnosc: number = 0;

  /**  */
  ktora_cena: number = 0;

  /**  */
  opis: string = '';

  podstrona_nr: number = 0;
  /**  */
  rodz_pokoi: string = '';

  /**  */
  www_rodz_pokoi_id: number = 0;

  constructor(data?: any) {
    if (data) {
      this['cena_brak'] = data['cena_brak'];
      this['cena_os1'] = data['cena_os1'];
      this['cena_os2'] = data['cena_os2'];
      this['cena_os3'] = data['cena_os3'];
      this['cena_os4'] = data['cena_os4'];
      this['cena_pokoj'] = data['cena_pokoj'];
      this['foto'] = data['foto'];
      this['ilosc_dni_min'] = data['ilosc_dni_min'];
      this['ilosc_miejsc'] = data['ilosc_miejsc'];
      this['info'] = data['info'];
      this['kolejnosc'] = data['kolejnosc'];
      this['ktora_cena'] = data['ktora_cena'];
      this['opis'] = data['opis'];
      this['podstrona_nr'] = data['podstrona_nr'];
      this['rodz_pokoi'] = data['rodz_pokoi'];
      this['www_rodz_pokoi_id'] = data['www_rodz_pokoi_id'];
    }
  }
}

export class webRoomDetails {
  /** www_rodz_pokoi_id */
  id: number = 0;

  /** rodz_pokoi - np. PKSN */
  roomCategory: string = '';

  title: string = '';

  /** krótki opis na karcie (opis) Apartament SENATOR */
  short: string = '';

  /** ilość miejsc w pokoju ilosc_miejsc '2' */
  persons: number = 0;

  /** ilość pokoi tej kategorii */
  totalRooms: number = 0;

  /** ilość wolnych pokoi tej kategorii */
  vacantRooms: number = 0;

  /** cena_pokoj, - bez groszy '99999' */
  price: number = 0;

  /** cena_os1, - bez groszy '99999' */
  price1: number = 0;

  /** cena_os2, - bez groszy '99999' */
  price2: number = 0;

  /** cena_os3, - bez groszy '99999' */
  price3: number = 0;

  /** cena_os4, - bez groszy '99999' */
  price4: number = 0;

  /** cena_brak, - bez groszy '99999' */
  price_empty: number = 0;

  /** opcja do zaznaczenia 1 */
  checkOption1: string = '';

  /** opcja do zaznaczenia 2 */
  checkOption2: string = '';

  /** opcja do zaznaczenia 3 */
  checkOption3: string = '';

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['roomCategory'] = data['roomCategory'];
      this['title'] = data['title'];
      this['short'] = data['short'];
      this['persons'] = data['persons'];
      this['totalRooms'] = data['totalRooms'];
      this['vacantRooms'] = data['vacantRooms'];
      this['price'] = data['price'];
      this['price1'] = data['price1'];
      this['price2'] = data['price2'];
      this['price3'] = data['price3'];
      this['price4'] = data['price4'];
      this['price_empty'] = data['price_empty'];
      this['checkOption1'] = data['checkOption1'];
      this['checkOption2'] = data['checkOption2'];
      this['checkOption3'] = data['checkOption3'];
    }
  }
}

export class image {
  /** url zdjęcia */
  url: string = '';

  /** url miniatury */
  thumbnails: string = '';

  /** krótki opis */
  alias: string = '';

  constructor(data?: any) {
    if (data) {
      this['url'] = data['url'];
      this['thumbnails'] = data['thumbnails'];
      this['alias'] = data['alias'];
    }
  }
}

export class webRoomGallery {
  /** rodz_pokoi - np. PKSN */
  roomCategory: string = '';

  /** dane o wolnych pokojach w danym dniu */
  images: image[] = [];

  constructor(data?: any) {
    if (data) {
      this['roomCategory'] = data['roomCategory'];
      this['images'] = data['images'];
    }
  }
}


export class ReservRoom {
  /** data zameldowania */
  check_in: string = '';

  /** data wymeldowania */
  check_out: string = '';

  /** kategoria pokoju */
  roomCategory: string = '';

  /** ilość miejsc */
  quantity: number = 0;

  /** opcja / cena za miejsce */
  price: number = 0;

  constructor(data?: any) {
    if (data) {
      this['check_in'] = data['check_in'];
      this['check_out'] = data['check_out'];
      this['roomCategory'] = data['roomCategory'];
      this['quantity'] = data['quantity'];
      this['price'] = data['price'];
    }
  }
}

export class Rezerwacja {
  /** data zameldowania */
  data_od: string = '';

  /** data wymeldowania */
  data_do: string = '';

  /** kategoria pokoju */
  rodz_pokoi: string = '';

  /** kategoria pokoju */
  www_rodz_pokoi_id: string = '';

  /** ilość miejsc */
  ilosc_osob: string = '';

  /** cena za miejsce */
  cena_pokoj: string = '';

  /** 0/1/2 - za pokoj/za osobe/za nosob */
  ktora_cena: string = '';

  /** JAN */
  gosc_nazwisko: string = '';

  /** kowalski.jan@gmail.com */
  gosc_e_mail: string = '';

  /** 606257683 */
  gosc_telefon: string = '';

  /** uwag kilka kolegi wilka */
  notes_tresc: string = '';

  /** pl */
  domena: string = '';

  /** 101 */
  pokoj_nr: string = '';

  ilosc_pokoi: string = '';

  //tag_uwagi_01: string = '';
  tag_uwagi_02: string = '';
  tag_uwagi_03: string = '';
  tag_uwagi_04: string = '';
  tag_uwagi_05: string = '';
  tag_uwagi_06: string = '';
  tag_uwagi_07: string = '';
  tag_uwagi_08: string = '';
  tag_uwagi_09: string = '';
  tag_uwagi_10: string = '';
  tag_uwagi_11: string = '';
  tag_uwagi_12: string = '';
  tag_uwagi_13: string = '';
  tag_uwagi_14: string = '';
  //tag_uwagi_15: string = '';

  /** 0/1/2/3/4
   brak/web/webManager/mobile/mobileManager */
  zrodlo_danych: string = '';

  /**  */
  json_wersja_nr: string = '';

  /**  */
  liczba_losowa: string = '';

  /** 1/2/3/4 
   free/book/busy/off jeśli brak to status_id=2, wolny - free/rezerwacja - book/meldunek - busy/wyłączenie - off */
  status_id: string = '';

  gosc_id: string = '';

  gosc_dowod_nr: string = '';
  gosc_imiona_rodz: string = '';
  gosc_data_ur: string = '';
  gosc_miejsce_ur: string = '';
  gosc_adres: string = '';

  constructor(data?: any) {
    if (data) {
      this['data_od'] = data['data_od'];
      this['data_do'] = data['data_do'];
      this['rodz_pokoi'] = data['rodz_pokoi'];
      this['www_rodz_pokoi_id'] = data['www_rodz_pokoi_id'];
      this['ilosc_osob'] = data['ilosc_osob'];
      this['cena_pokoj'] = data['cena_pokoj'];
      this['ktora_cena'] = data['ktora_cena'];
      this['gosc_nazwisko'] = data['gosc_nazwisko'];
      this['gosc_e_mail'] = data['gosc_e_mail'];
      this['gosc_telefon'] = data['gosc_telefon'];
      this['notes_tresc'] = data['notes_tresc'];
      this['domena'] = data['domena'];
      this['pokoj_nr'] = data['pokoj_nr'];
      this['zrodlo_danych'] = data['zrodlo_danych'];
      this['ilosc_pokoi'] = data['ilosc_pokoi'];
      //this['tag_uwagi_01'] = data['tag_uwagi_01'];
      this['tag_uwagi_02'] = data['tag_uwagi_02'];
      this['tag_uwagi_03'] = data['tag_uwagi_03'];
      this['tag_uwagi_04'] = data['tag_uwagi_04'];
      this['tag_uwagi_05'] = data['tag_uwagi_05'];
      this['tag_uwagi_06'] = data['tag_uwagi_06'];
      this['tag_uwagi_07'] = data['tag_uwagi_07'];
      this['tag_uwagi_08'] = data['tag_uwagi_08'];
      this['tag_uwagi_09'] = data['tag_uwagi_09'];
      this['tag_uwagi_10'] = data['tag_uwagi_10'];
      this['tag_uwagi_11'] = data['tag_uwagi_11'];
      this['tag_uwagi_12'] = data['tag_uwagi_12'];
      this['tag_uwagi_13'] = data['tag_uwagi_13'];
      this['tag_uwagi_14'] = data['tag_uwagi_14'];
      //this['tag_uwagi_15'] = data['tag_uwagi_15'];
      this['json_wersja_nr'] = data['json_wersja_nr'];
      this['liczba_losowa'] = data['liczba_losowa'];
      this['status_id'] = data['status_id'];

      // this['profit_room_code'] = data['profit_room_code'];
      this['gosc_id'] = data['gosc_id'];
      // this['www_portal_id'] = data['www_portal_id'];
      // this['www_portal_resid_value'] = data['www_portal_resid_value'];
      // this['kontr_nazwa'] = data['kontr_nazwa'];
      // this['kontr_adres'] = data['kontr_adres'];
      // this['kontr_nip'] = data['kontr_nip'];
      this['gosc_dowod_nr'] = data['gosc_dowod_nr'];
      this['gosc_imiona_rodz'] = data['gosc_imiona_rodz'];
      this['gosc_data_ur'] = data['gosc_data_ur'];
      this['gosc_miejsce_ur'] = data['gosc_miejsce_ur'];
      this['gosc_adres'] = data['gosc_adres'];

    }
  }
}

// Generated by https://quicktype.io

export class RezerwacjaPobyt {
  pobyt_id: number = 0;
  status_id: number = 0;
  pobyt_od: string = '';
  pobyt_do: string = '';
  rodz_pokoi: string = '';
  www_rodz_pokoi_id: number = 0;
  pokoj_nr: string = '';
  rodz_pokoi_opis: string = '';
  ilosc_osob: number = 0;
  ilosc_miejsc: number = 0;
  cena_pokoj: string = '';
  gosc_nazwisko: string = '';
  gosc_telefon: string = '';
  gosc_e_mail: string = '';
  notes_tresc: string = '';
  domena: string = '';
  tag_uwagi_02: string = '';
  tag_uwagi_03: string = '';
  tag_uwagi_04: string = '';
  tag_uwagi_05: string = '';
  tag_uwagi_06: string = '';
  tag_uwagi_07: string = '';
  tag_uwagi_08: string = '';
  tag_uwagi_09: string = '';
  tag_uwagi_10: string = '';
  tag_uwagi_11: string = '';
  tag_uwagi_12: string = '';
  tag_uwagi_13: string = '';
  tag_uwagi_14: string = '';
  opcje: string = '';
  brutto: string = '';
  zaliczki: string = '';
  do_zaplaty: string = '';

  constructor(data?: any) {
    if (data) {
      this['pobyt_id'] = data['pobyt_id'];
      this['status_id'] = data['status_id'];
      this['pobyt_od'] = data['pobyt_od'];
      this['pobyt_do'] = data['pobyt_do'];
      this['rodz_pokoi'] = data['rodz_pokoi'];
      this['www_rodz_pokoi_id'] = data['www_rodz_pokoi_id'];
      this['pokoj_nr'] = data['pokoj_nr'];
      this['rodz_pokoi_opis'] = data['rodz_pokoi_opis'];
      this['ilosc_osob'] = data['ilosc_osob'];
      this['ilosc_miejsc'] = data['ilosc_miejsc'];
      this['cena_pokoj'] = data['cena_pokoj'];
      this['gosc_nazwisko'] = data['gosc_nazwisko'];
      this['gosc_telefon'] = data['gosc_telefon'];
      this['gosc_e_mail'] = data['gosc_e_mail'];
      this['notes_tresc'] = data['notes_tresc'];
      this['domena'] = data['domena'];
      this['tag_uwagi_02'] = data['tag_uwagi_02'];
      this['tag_uwagi_03'] = data['tag_uwagi_03'];
      this['tag_uwagi_04'] = data['tag_uwagi_04'];
      this['tag_uwagi_05'] = data['tag_uwagi_05'];
      this['tag_uwagi_06'] = data['tag_uwagi_06'];
      this['tag_uwagi_07'] = data['tag_uwagi_07'];
      this['tag_uwagi_08'] = data['tag_uwagi_08'];
      this['tag_uwagi_09'] = data['tag_uwagi_09'];
      this['tag_uwagi_10'] = data['tag_uwagi_10'];
      this['tag_uwagi_11'] = data['tag_uwagi_11'];
      this['tag_uwagi_12'] = data['tag_uwagi_12'];
      this['tag_uwagi_13'] = data['tag_uwagi_13'];
      this['tag_uwagi_14'] = data['tag_uwagi_14'];
      this['opcje'] = data['opcje'];
      this['brutto'] = data['brutto'];
      this['zaliczki'] = data['zaliczki'];
      this['do_zaplaty'] = data['do_zaplaty'];
    }
  }
}


export class Reservation {
  /** kod hotelu */
  hotelId: string = '';

  /** klucz dostępu */
  key: string = '';

  /** jezyk */
  lang: string = '';

  /** JAN */
  name: string = '';

  /** KOWALSKI */
  surname: string = '';

  /** kowalski.jan@gmail.com */
  email: string = '';

  /** 606257683 */
  phone: string = '';

  /** uwag kilka kolegi wilka */
  remarks: string = '';

  reservations: ReservRoom[] = [];

  constructor(data?: any) {
    if (data) {
      this['hotelId'] = data['hotelId'];
      this['key'] = data['key'];
      this['lang'] = data['lang'];
      this['name'] = data['name'];
      this['email'] = data['email'];
      this['phone'] = data['phone'];
      this['remarks'] = data['remarks'];
      this['reservations'] = data['reservations'];
    }
  }
}


export class ReservationId {
  /** identyfikator */
  result: number[] = [0];


  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class StanId {
  /** identyfikator */
  result: number = 0;


  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class grafik {
  /** pokoje - do wyśietlenia na stronie internetowej */
  result: grafikOgolnyPokoje[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class grafikOgolnyPokoje {

  _data_font_kolor: string = '';
  _data_opis: string = '';
  _data_tlo_kolor: string = '';
  _font_kolor: string = '';
  _kolumna: number = 0;
  _tlo_kolor: string = '';
  _wiersz: number = 0;
  data: string = '';
  dataFontKolor: string = '';
  dataOpis: string = '';
  dataTloKolor: string = '';
  dostepna_ilosc_pokoi: number = 0;
  fontKolor: string = '';
  kolumna: number = 0;
  opis: string = '';
  podstrona_nr: number= 0;
  pokoje_dostepne: number = 0;
  rodz_pokoi: string = '';
  tloKolor: string = '';
  wiersz: number = 0;
  www_rodz_pokoi_id: number = 0;

  constructor(data?: any) {
    if (data) {
      this['_data_font_kolor'] = data['_data_font_kolor'];
      this['_data_opis'] = data['_data_opis'];
      this['_data_tlo_kolor'] = data['_data_tlo_kolor'];
      this['_font_kolor'] = data['_font_kolor'];
      this['_kolumna'] = data['_kolumna'];
      this['_tlo_kolor'] = data['_tlo_kolor'];
      this['_wiersz'] = data['_wiersz'];
      this['data'] = data['data'];
      this['dataFontKolor'] = data['dataFontKolor'];
      this['dataOpis'] = data['dataOpis'];
      this['dostepna_ilosc_pokoi'] = data['dostepna_ilosc_pokoi'];
      this['fontKolor'] = data['fontKolor'];
      this['kolumna'] = data['kolumna'];
      this['opis'] = data['opis'];
      this['podstrona_nr'] = data['podstrona_nr'];
      this['pokoje_dostepne'] = data['pokoje_dostepne'];
      this['rodz_pokoi'] = data['rodz_pokoi'];
      this['tloKolor'] = data['tloKolor'];
      this['wiersz'] = data['rwiersz'];
      this['www_rodz_pokoi_id'] = data['www_rodz_pokoi_id'];
    }
  }
}

export class calendarRow {
  /** klucz (kategoria pokoju) */
  id: string = '';

  /** opis (pokój) - skala pionowa */
  info: string = '';

  /**  */
  color: string = '';

  /** dane o wolnych pokojach w danym dniu */
  days: string[] = [];

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['info'] = data['info'];
      this['color'] = data['color'];
      this['days'] = data['days'];
    }
  }
}

export class webCalendar {
  /** data początkowa */
  date: string = '';

  /** ilość dni */
  days: number = 0;

  /** dane dla pokojów */
  rows: calendarRow[] = [];

  constructor(data?: any) {
    if (data) {
      this['date'] = data['date'];
      this['days'] = data['days'];
      this['rows'] = data['rows'];
    }
  }
}

export class Dostepnosc {
  /** identyfikator */
  result: dostepnoscPokoju[] = [];


  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class dostepnoscPokoju {
  /** nr pokoju */
  pokoj: number = 0;

  /** uwaga dotyczaca pokoju */
  opis: string = '';

  /**  */
  ilosc_miejsc: number = 0;

  /**  */
  ktora_cena: number = 0;

  /**  */
  cena_brak: number = 0;

  /** domyslna cena pokoju */
  cena_pokoj: number = 0;

  /**  */
  cena_os1: number = 0;

  /**  */
  cena_os2: number = 0;

  /**  */
  cena_os3: number = 0;

  /**  */
  cena_os4: number = 0;

  constructor(data?: any) {
    if (data) {
      this['pokoj'] = data['pokoj'];
      this['opis'] = data['opis'];
      this['ilosc_miejsc'] = data['ilosc_miejsc'];
      this['ktora_cena'] = data['ktora_cena'];
      this['cena_brak'] = data['cena_brak'];
      this['cena_pokoj'] = data['cena_pokoj'];
      this['cena_os1'] = data['cena_os1'];
      this['cena_os2'] = data['cena_os2'];
      this['cena_os3'] = data['cena_os3'];
      this['cena_os4'] = data['cena_os4'];
    }
  }
}
export class Ceny {

  data: string = '';
  dzien_tygodnia: string = '';
  ktora_cena: number = 0;
  cena_brak: number = 0;
  cena_pokoj: number = 0;
  cena_os1: number = 0;
  cena_os2: number = 0;
  cena_os3: number = 0;
  cena_os4: number = 0;

  constructor(data?: any) {
    if (data) {
      this['data'] = data['data'];
      this['dzien_tygodnia'] = data['dzien_tygodnia'];
      this['ktora_cena'] = data['ktora_cena'];
      this['cena_brak'] = data['cena_brak'];
      this['cena_pokoj'] = data['cena_pokoj'];
      this['cena_os1'] = data['cena_os1'];
      this['cena_os2'] = data['cena_os2'];
      this['cena_os3'] = data['cena_os3'];
      this['cena_os4'] = data['cena_os4'];
    }
  }
}

// Generated by https://quicktype.io

export class PokojDzien {
  dataFontKolor: string = '';
  iloscPokoi: number = 0;
  wierszFontKolor: string = '';
  dataOpis: string = '';
  data: string = '';
  _data: string = '';
  _data_opis: string = '';
  _data_font_kolor: string = '';
  _ilosc_pokoi: number = 0;
  _wiersz_font_kolor: string = '';
  pobyt_id: string = '';
  pokoj: string = '';
  status: string = '';
  pokoi: number = 0;
  osob: number = 0;
  rodzaj: string = '';
  nazwisko: string = '';
  przyjazd: string = '';
  wyjazd: string = '';
  dni: number = 0;
  tag_kanal_opis: string = '';
  opcje: string = '';

  constructor(data?: any) {
    if (data) {
      this._data = data._data;
      this._data_font_kolor = data._data_font_kolor;
      this._data_opis = data._data_opis;
      this._ilosc_pokoi = data._ilosc_pokoi;
      this._wiersz_font_kolor = data._wiersz_font_kolor;
      this.data = data.data;
      this.dataFontKolor = data.dataFontKolor;
      this.dataOpis = data.dataOpis;
      this.dni = data.dni;
      this.iloscPokoi = data.iloscPokoi;
      this.nazwisko = data.nazwisko;
      this.opcje = data.opcje;
      this.osob = data.osob;
      this.pokoi = data.pokoi;
      this.pokoj = data.pokoj;
      this.przyjazd = data.przyjazd;
      this.rodzaj = data.rodzaj;
      this.status = data.status;
      this.tag_kanal_opis = data.tag_kanal_opis;
      this.wierszFontKolor = data.wierszFontKolor;
      this.wyjazd = data.wyjazd;
      this.pobyt_id = data.pobyt_id
    }
  }
}

export class pokojeDni {

  result: pokojDni[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class pokojDni {
  _data_font_kolor: string = '';
  _data_opis: string = '';
  data: string = '';
  dataFontKolor: string = '';
  dataOpis: string = '';
  pobyt_ilosc_osob: string = '';
  pobyt_ilosc_pokoi: string = '';
  przyjazd_ilosc_osob: string = '';
  przyjazd_ilosc_pokoi: string = '';
  wyjazd_ilosc_osob: string = '';
  wyjazd_ilosc_pokoi: string = '';

  constructor(data?: any) {
    if (data) {
      this['_data_font_kolor'] = data['_data_font_kolor'];
      this['_data_opis'] = data['_data_opis'];
      this['data'] = data['data'];
      this['dataFontKolor'] = data['dataFontKolor'];
      this['dataOpis'] = data['dataOpis'];
      this['pobyt_ilosc_osob'] = data['pobyt_ilosc_osob'];
      this['pobyt_ilosc_pokoi'] = data['pobyt_ilosc_pokoi'];
      this['przyjazd_ilosc_osob'] = data['przyjazd_ilosc_osob'];
      this['przyjazd_ilosc_pokoi'] = data['przyjazd_ilosc_pokoi'];
      this['wyjazd_ilosc_osob'] = data['wyjazd_ilosc_osob'];
      this['wyjazd_ilosc_pokoi'] = data['wyjazd_ilosc_pokoi'];
    }
  }
}

export class posilkiDzien {

  result: posilekDzien[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class posilekDzien {
  _data: string = '';
  _data_opis: string = '';
  _ilosc_pokoi: number = 0;
  _ilosc_posilkow: number = 0;
  _wiersz_font_kolor: string = '';
  data: string = '';
  dataOpis: string = '';
  ilosc: string = '';
  iloscPokoi: number = 0;
  iloscPosilkow: number = 0;
  nazwisko: string = '';
  pokoj: string = '';
  posilek: string = '';
  wierszFontKolor: string = '';

  constructor(data?: any) {
    if (data) {
      this['_data'] = data['_data'];
      this['_data_opis'] = data['_data_opis'];
      this['_ilosc_pokoi'] = data['_ilosc_pokoi'];
      this['_ilosc_posilkow'] = data['_ilosc_posilkow'];
      this['_wiersz_font_kolor'] = data['_wiersz_font_kolor'];
      this['data'] = data['data'];
      this['dataOpis'] = data['dataOpis'];
      this['ilosc'] = data['ilosc'];
      this['iloscPokoi'] = data['iloscPokoi'];
      this['iloscPosilkow'] = data['iloscPosilkow'];
      this['nazwisko'] = data['nazwisko'];
      this['pokoj'] = data['pokoj'];
      this['posilek'] = data['posilek'];
      this['wierszFontKolor'] = data['wierszFontKolor'];
    }
  }
}

export class posilkiDni {

  result: posilekDni[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class posilekDni {
  _data_font_kolor: string = '';
  _data_opis: string = '';
  data: string = '';
  dataFontKolor: string = '';
  dataOpis: string = '';
  ilosc: string = '';
  posilek: string = '';

  constructor(data?: any) {
    if (data) {
      this['_data_font_kolor'] = data['_data_font_kolor'];
      this['_data_opis'] = data['_data_opis'];
      this['data'] = data['data'];
      this['dataFontKolor'] = data['dataFontKolor'];
      this['dataOpis'] = data['dataOpis'];
      this['ilosc'] = data['ilosc'];
      this['posilek'] = data['posilek'];
    }
  }
}

export class pokojeStany {

  result: pokojeStan[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class pokojeStan {
  _pobyt_ikona: string = '';
  _pobyt_ikona_nr: number = 0;
  _pobyt_ilosc: number = 0;
  _pobyt_opis: string = '';
  _pobyt_opis1: string = '';
  _przyjazd_ikona: string = '';
  _przyjazd_ikona_nr: number = 0;
  _przyjazd_ilosc: number = 0;
  _przyjazd_opis: string = '';
  _przyjazd_opis1: string = '';
  _stan_akcja_nr: number = 0;
  _stan_ikona_nr: number = 0;
  _wyjazd_ikona: string = '';
  _wyjazd_ikona_nr: number = 0;
  _wyjazd_ilosc: number = 0;
  _wyjazd_opis: string = '';
  _wyjazd_opis1: string = '';
  czysty: number = 0;
  opis: string = '';
  opuszczony: number = 0;
  pobytIkona: string = '';
  pobytIkonaNr: number = 0;
  pobytIlosc: number = 0;
  pobytOpis: string = '';
  pobytOpis1: string = '';
  pobyt_data_do: string = '';
  pobyt_data_od: string = '';
  pobyt_pobyt_id: number = 0;
  pokoj: string = '';
  przyjazdIkona: string = '';
  przyjazdIkonaNr: number = 0;
  przyjazdIlosc: number = 0;
  przyjazdOpis: string = '';
  przyjazdOpis1: string = '';
  przyjazd_data_do: string = '';
  przyjazd_pobyt_id: number = 0;
  rodz: string = '';
  stanAkcjaNr: number = 0;
  stanIkonaNr: number = 0;
  wyjazdIkona: string = '';
  wyjazdIkonaNr: number = 0;
  wyjazdIlosc: number = 0;
  wyjazdOpis: string = '';
  wyjazdOpis1: string = '';
  wyjazd_pobyt_id: number = 0;

  constructor(data?: any) {
    if (data) {
      this['_pobyt_ikona'] = data['_pobyt_ikona'];
      this['_pobyt_ikona_nr'] = data['_pobyt_ikona_nr'];
      this['_pobyt_ilosc'] = data['_pobyt_ilosc'];
      this['_pobyt_opis'] = data['_pobyt_opis'];
      this['_pobyt_opis1'] = data['_pobyt_opis1'];
      this['_przyjazd_ikona'] = data['_przyjazd_ikona'];
      this['_przyjazd_ikona_nr'] = data['_przyjazd_ikona_nr'];
      this['_przyjazd_ilosc'] = data['_przyjazd_ilosc'];
      this['_przyjazd_opis'] = data['_przyjazd_opis'];
      this['_przyjazd_opis1'] = data['_przyjazd_opis1'];
      this['_stan_akcja_nr'] = data['_stan_akcja_nr'];
      this['_stan_ikona_nr'] = data['_stan_ikona_nr'];
      this['_wyjazd_ikona'] = data['_wyjazd_ikona'];
      this['_wyjazd_ikona_nr'] = data['_wyjazd_ikona_nr'];
      this['_wyjazd_ilosc'] = data['_wyjazd_ilosc'];
      this['_wyjazd_opis'] = data['_wyjazd_opis'];
      this['_wyjazd_opis1'] = data['_wyjazd_opis1'];
      this['czysty'] = data['czysty'];
      this['opis'] = data['opis'];
      this['opuszczony'] = data['opuszczony'];
      this['pobytIkona'] = data['pobytIkona'];
      this['pobytIkonaNr'] = data['pobytIkonaNr'];
      this['pobytIlosc'] = data['pobytIlosc'];
      this['pobytOpis'] = data['pobytOpis'];
      this['pobytOpis1'] = data['pobytOpis1'];
      this['pobyt_data_do'] = data['pobyt_data_do'];
      this['pobyt_data_od'] = data['pobyt_data_od'];
      this['pobyt_pobyt_id'] = data['pobyt_pobyt_id'];
      this['pokoj'] = data['pokoj'];
      this['przyjazdIkona'] = data['przyjazdIkona'];
      this['przyjazdIkonaNr'] = data['przyjazdIkonaNr'];
      this['przyjazdIlosc'] = data['przyjazdIlosc'];
      this['przyjazdOpis'] = data['przyjazdOpis'];
      this['przyjazdOpis1'] = data['przyjazdOpis1'];
      this['przyjazd_data_do'] = data['przyjazd_data_do'];
      this['przyjazd_pobyt_id'] = data['przyjazd_pobyt_id'];
      this['rodz'] = data['rodz'];
      this['stanAkcjaNr'] = data['stanAkcjaNr'];
      this['stanIkonaNr'] = data['stanIkonaNr'];
      this['wyjazdIkona'] = data['wyjazdIkona'];
      this['wyjazdIkonaNr'] = data['wyjazdIkonaNr'];
      this['wyjazdIlosc'] = data['wyjazdIlosc'];
      this['wyjazdOpis'] = data['wyjazdOpis'];
      this['wyjazdOpis1'] = data['wyjazdOpis1'];
      this['wyjazd_pobyt_id'] = data['wyjazd_pobyt_id'];
    }
  }
}


export class PokojOpcje {

  result: PokojOpcja[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class PokojOpcja {
  aktywna: string = '';
  opcja: string = '';
  opis: string = '';

  constructor(data?: any) {
    if (data) {
      this['aktywna'] = data['aktywna'];
      this['opcja'] = data['opcja'];
      this['opis'] = data['opis'];
    }
  }
}

export class Pobyty {
  /** pokoje - do wyśietlenia na stronie internetowej */
  result: Pobyt[] = []

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}


export class Pobyt {
  _data_do_opis: string = '';
  _data_od_opis: string = '';
  dataDoOpis: string = '';
  dataOdOpis: string = '';
  dni: number = 0;
  fontKolor: string = '';
  nazwisko: string = '';
  opcje: string = '';
  osob: number = 0;
  pobyt_id: number = 0;
  pokoj: string = '';
  przyjazd: string = '';
  rodzaj: string = '';
  tag_kanal_opis: string = '';
  wyjazd: string = '';

  constructor(data?: any) {
    if (data) {
      this['_data_do_opis'] = data['_data_do_opis'];
      this['_data_od_opis'] = data['_data_od_opis'];
      this['dataDoOpis'] = data['dataDoOpis'];
      this['dataOdOpis'] = data['dataOdOpis'];
      this['dni'] = data['dni'];
      this['fontKolor'] = data['fontKolor'];
      this['nazwisko'] = data['nazwisko'];
      this['opcje'] = data['opcje'];
      this['osob'] = data['osob'];
      this['pobyt_id'] = data['pobyt_id'];
      this['pokoj'] = data['pokoj'];
      this['przyjazd'] = data['przyjazd'];
      this['rodzaj'] = data['rodzaj'];
      this['tag_kanal_opis'] = data['tag_kanal_opis'];
      this['wyjazd'] = data['wyjazd'];
    }
  }
}

export class RoomsNames {
  /** pokoje - do wyśietlenia na stronie internetowej */
  result: RoomsName[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class RoomsName {

  _font_kolor: string = '';
  _tlo_kolor: string = '';
  _wiersz: number = 0;
  fontKolor: string = '';
  opis: string = '';
  tloKolor: string = '';
  wiersz: number = 0;
  www_rodz_pokoi_id: number = 0;

  constructor(data?: any) {
    if (data) {
      this['_font_kolor'] = data['_font_kolor'];
      this['_tlo_kolor'] = data['_tlo_kolor'];
      this['_wiersz'] = data['_wiersz'];
      this['fontKolor'] = data['fontKolor'];
      this['opis'] = data['opis'];
      this['tloKolor'] = data['tloKolor'];
      this['wiersz'] = data['rwiersz'];
      this['www_rodz_pokoi_id'] = data['www_rodz_pokoi_id'];
    }
  }
}

export class PortalInfo {
  /** pokoje - do wyśietlenia na stronie internetowej */
  result: Info[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}


export class Info {

  domena: string = '';
  googleMaps: string = '';
  info: string = '';
  kontaktAdres: string = '';
  kontaktEmail: string = '';
  kontaktFax: string = '';
  kontaktGps: string = '';
  kontaktTelefon: string = '';
  materialuiZestawNr: string = '';
  opis: string = '';
  payWeb: string = ''; //0/1/2/3 brak/P24/CashBill/SmsKod
  preautoryzacja: string = ''; //0/1 przelew/preautoryzacja

  constructor(data?: any) {
    if (data) {
      this.domena = data.domena;
      this.googleMaps = data.googleMaps;
      this.info = data.info;
      this.kontaktAdres = data.kontaktAdres;
      this.kontaktEmail = data.kontaktEmail;
      this.kontaktFax = data.kontaktFax;
      this.kontaktGps = data.kontaktGps;
      this.kontaktTelefon = data.kontaktTelefon;
      this.materialuiZestawNr = data.materialuiZestawNr;
      this.opis = data.opis;
      this.payWeb = data.payWeb;
      this.preautoryzacja = data.preautoryzacja;
    }
  }
}

export class Amount {
  /**  */
  value: number = 0;

  /**  */
  currencyCode: string = '';

  constructor(data?: any) {
    if (data) {
      this['value'] = data['value'];
      this['currencyCode'] = data['currencyCode'];
    }
  }
}

export class requestedAmount {
  /**  */
  value: number = 0;

  /**  */
  currencyCode: string = '';

  constructor(data?: any) {
    if (data) {
      this['value'] = data['value'];
      this['currencyCode'] = data['currencyCode'];
    }
  }
}

export class personalData {
  /**  */
  firstName: string = '';

  /**  */
  surname: string = '';

  /**  */
  email: string = '';

  /**  */
  country: string = '';

  /**  */
  city: string = '';

  /**  */
  postcode: string = '';

  /**  */
  street: string = '';

  /**  */
  house: string = '';

  /**  */
  flat: string = '';

  /**  */
  ip: string = '';

  constructor(data?: any) {
    if (data) {
      this['firstName'] = data['firstName'];
      this['surname'] = data['surname'];
      this['email'] = data['email'];
      this['country'] = data['country'];
      this['city'] = data['city'];
      this['postcode'] = data['postcode'];
      this['street'] = data['street'];
      this['house'] = data['house'];
      this['flat'] = data['flat'];
      this['ip'] = data['ip'];
    }
  }
}

export class payStatus {
  /**  */
  id: string = '';

  /**  */
  paymentChannel: string = '';

  /**  */
  amount: Amount = new Amount();

  /**  */
  requestedAmount: requestedAmount = new requestedAmount();

  /**  */
  title: string = '';

  /**  */
  description: string = '';

  /**  */
  personalData: personalData = new personalData();

  /**  */
  additionalData: string = '';

  /**  */
  status: string = '';

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['paymentChannel'] = data['paymentChannel'];
      this['amount'] = data['amount'];
      this['requestedAmount'] = data['requestedAmount'];
      this['title'] = data['title'];
      this['description'] = data['description'];
      this['personalData'] = data['personalData'];
      this['additionalData'] = data['additionalData'];
      this['status'] = data['status'];
    }
  }
}

// export class payStatusPrzelewy24 {
//   akcjaDtMinut: string = '';
//   akcjaDtStart: string = '';
//   akcjaDtStop: string = '';
//   akcjaStatus: string = '';
//   akcjaWynik: string = '';

//   constructor(data?: any) {
//     if (data) {
//       this['akcjaDtMinut'] = data['akcjaDtMinut'];
//       this['akcjaDtStart'] = data['akcjaDtStart'];
//       this['akcjaDtStop'] = data['akcjaDtStop'];
//       this['akcjaStatus'] = data['akcjaStatus'];
//       this['akcjaWynik'] = data['akcjaWynik'];
//     }
//   }
// }

export class payTest1 {
  /**  */
  id: string = '';

  /**  */
  availableCurrencies: string[] = [];

  /**  */
  name: string = '';

  /**  */
  description: string = '';

  /**  */
  logoUrl: string = '';

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['availableCurrencies'] = data['availableCurrencies'];
      this['name'] = data['name'];
      this['description'] = data['description'];
      this['logoUrl'] = data['logoUrl'];
    }
  }
}

export class vscPayment {
  /** platnosc id */
  id: string = '';

  /** url do platnosci */
  redirectUrl: string = '';

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['redirectUrl'] = data['redirectUrl'];
    }
  }
}

export class vscPaymentPrzelewy24 {
  /** kod */
  code: number = 0;

  /** url do platnosci */
  result: string = '';

  constructor(data?: any) {
    if (data) {
      this['code'] = data['code'];
      this['result'] = data['result'];
    }
  }
}

export class Przelewy24Status {
  data: Przelewy24StatusData = new Przelewy24StatusData();
  responseCode: number = 0;
  constructor(data?: any) {
    if (data) {
      this['data'] = data['data'];
      this['responseCode'] = data['responseCode'];
    }
  }
}

export class Przelewy24StatusData {
  //accountMD5: string = '';
  amount: number = 0;
  //batchId: number = 0;
  //clientAddress: string = '';
  //clientCity: string = '';
  //clientEmail: string = '';
  //clientName: string = '';
  //clientPostcode: string = '';
  currency: string = '';
  date: string = '';
  //dateOfTransaction: string = '';
  description: string = '';
  //fee: string = '';
  orderId: number = 0;
  paymentMethod: number = 0;
  sessionId: string = '';
  statement: string = '';
  status: number = 0;

  constructor(data?: any) {
    if (data) {
      //this['accountMD5'] = data['accountMD5'];
      this['amount'] = data['amount'];
      //this['batchId'] = data['batchId'];
      //this['clientAddress'] = data['clientAddress'];
      //this['clientCity'] = data['clientCity'];
      //this['clientEmail'] = data['clientEmail'];
      //this['clientName'] = data['clientName'];
      //this['clientPostcode'] = data['clientPostcode'];
      this['currency'] = data['currency'];
      this['date'] = data['date'];
      //this['dateOfTransaction'] = data['dateOfTransaction'];
      this['description'] = data['description'];
      //this['fee'] = data['fee'];
      this['orderId'] = data['orderId'];
      this['paymentMethod'] = data['paymentMethod'];
      this['sessionId'] = data['sessionId'];
      this['statement'] = data['statement'];
      this['status'] = data['status'];
    }
  }
}


export class Fonts {
  result: Font[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}


export class Font {
  czcionkaId: number = 0;
  fontSize: number = 0;
  opis: string = '';
  fontWeight: string = '';
  color: string = '';
  fontFamily: string = '';
  aktywna: number = 0;

  constructor(data?: any) {
    if (data) {
      this['czcionkaId'] = data['czcionkaId'];
      this['fontSize'] = data['fontSize'];
      this['fontWeight'] = data['fontWeight'];
      this['color'] = data['color'];
      this['fontFamily'] = data['fontFamily'];
      this['aktywna'] = data['aktywna'];
      this['opis'] = data['opis'];
    }
  }
}

export class RaportUtargZaCoSuma {

  brutto: string = '';
  ceny_brutto: number = -1;
  data_wyst_do: string = '';
  data_wyst_od: string = '';
  dok_sprz_typ_do: string = '';
  dok_sprz_typ_od: string = '';
  gr_asort_do: string = '';
  gr_asort_od: string = '';
  netto: string = '';
  operator_id_do: string = '';
  operator_id_od: string = '';
  sp_zaplaty_do: string = '';
  sp_zaplaty_od: string = '';
  upust_wartosc: string = '';
  vat: string = '';
  zamkniety: number = -1;

  constructor(data?: any) {
    if (data) {
      this['brutto'] = data['brutto'];
      this['ceny_brutto'] = data['ceny_brutto'];
      this['data_wyst_do'] = data['data_wyst_do'];
      this['data_wyst_od'] = data['data_wyst_od'];
      this['dok_sprz_typ_do'] = data['dok_sprz_typ_do'];
      this['dok_sprz_typ_od'] = data['dok_sprz_typ_od'];
      this['gr_asort_do'] = data['gr_asort_do'];
      this['gr_asort_od'] = data['gr_asort_od'];
      this['netto'] = data['netto'];
      this['operator_id_do'] = data['operator_id_do'];
      this['operator_id_od'] = data['operator_id_od'];
      this['sp_zaplaty_do'] = data['sp_zaplaty_do'];
      this['sp_zaplaty_od'] = data['sp_zaplaty_od'];
      this['upust_wartosc'] = data['upust_wartosc'];
      this['vat'] = data['vat'];
      this['zamkniety'] = data['zamkniety'];
    }
  }
}

export class RaportUtargZaCoGrupaAsortymenty {

  _font_kolor: string = '';
  _font_styl: number = 0;
  _tlo_kolor: string = '';
  asort_id: string = '';
  brutto: string = '';
  fontKolor: string = '';
  fontStyl: number = 0;
  gr_asort: string = '';
  ilosc: string = '';
  kolor: number = 0;
  nazwa: string = '';
  netto: string = '';
  statystyka_brutto: string = '';
  statystyka_netto: string = '';
  statystyka_upust_wartosc: string = '';
  statystyka_vat: string = '';
  tloKolor: string = '';
  upust_wartosc: string = '';
  vat: string = '';
  vat_stawka: string = '';

  constructor(data?: any) {
    if (data) {
      this['_font_kolor'] = data['_font_kolor'];
      this['_font_styl'] = data['_font_styl'];
      this['_tlo_kolor'] = data['_tlo_kolor'];
      this['asort_id'] = data['asort_id'];
      this['brutto'] = data['brutto'];
      this['fontKolor'] = data['fontKolor'];
      this['fontStyl'] = data['fontStyl'];
      this['gr_asort'] = data['gr_asort'];
      this['ilosc'] = data['ilosc'];
      this['kolor'] = data['kolor'];
      this['nazwa'] = data['nazwa'];
      this['netto'] = data['netto'];
      this['statystyka_brutto'] = data['statystyka_brutto'];
      this['statystyka_netto'] = data['statystyka_netto'];
      this['statystyka_upust_wartosc'] = data['statystyka_upust_wartosc'];
      this['statystyka_vat'] = data['statystyka_vat'];
      this['tloKolor'] = data['tloKolor'];
      this['upust_wartosc'] = data['upust_wartosc'];
      this['vat'] = data['vat'];
      this['vat_stawka'] = data['vat_stawka'];
    }
  }
}

export class RaportUtargJakiOkresySuma {

  data_wyst_do: string = '';
  data_wyst_od: string = '';
  dok_sprz_typ_do: string = '';
  dok_sprz_typ_od: string = '';
  kwota: string = '';
  kwota_na_transakcje: string = '';
  transakcje: string = '';
  typ_okresu: string = '';

  constructor(data?: any) {
    if (data) {
      this['data_wyst_do'] = data['data_wyst_do'];
      this['data_wyst_od'] = data['data_wyst_od'];
      this['dok_sprz_typ_do'] = data['dok_sprz_typ_do'];
      this['dok_sprz_typ_od'] = data['dok_sprz_typ_od'];
      this['kwota'] = data['kwota'];
      this['kwota_na_transakcje'] = data['kwota_na_transakcje'];
      this['transakcje'] = data['transakcje'];
      this['typ_okresu'] = data['typ_okresu'];
    }
  }
}

export class RaportUtargJakiOkresyOkres {

  _font_kolor: string = '';
  _font_styl: number = 0;
  _tlo_kolor: string = '';
  fontKolor: string = '';
  fontStyl: number = 0;
  kolor: number = 0;
  kwota: string = '';
  kwota_na_transakcje: string = '';
  okres: string = '';
  statystyka_kwota: string = '';
  statystyka_kwota_na_trans: string = '';
  statystyka_transakcje: string = '';
  tloKolor: string = '';
  transakcje: string = '';

  constructor(data?: any) {
    if (data) {
      this['_font_kolor'] = data['_font_kolor'];
      this['_font_styl'] = data['_font_styl'];
      this['_tlo_kolor'] = data['_tlo_kolor'];
      this['fontKolor'] = data['fontKolor'];
      this['fontStyl'] = data['fontStyl'];
      this['kolor'] = data['kolor'];
      this['kwota'] = data['kwota'];
      this['kwota_na_transakcje'] = data['kwota_na_transakcje'];
      this['okres'] = data['okres'];
      this['statystyka_kwota'] = data['statystyka_kwota'];
      this['statystyka_kwota_na_trans'] = data['statystyka_kwota_na_trans'];
      this['statystyka_transakcje'] = data['statystyka_transakcje'];
      this['tloKolor'] = data['tloKolor'];
      this['transakcje'] = data['transakcje'];
    }
  }
}

export class RaportUtargJakiSpZaplatySuma {

  data_wyst_do: string = '';
  data_wyst_od: string = '';
  do_zaplaty: string = '';
  dok_sprz_typ_do: string = '';
  dok_sprz_typ_od: string = '';
  kwota: string = '';
  operator_id_do: string = '';
  operator_id_od: string = '';
  sp_zaplaty_do: string = '';
  sp_zaplaty_od: string = '';
  transakcje: string = '';
  zaliczka: string = '';

  constructor(data?: any) {
    if (data) {
      this['data_wyst_do'] = data['data_wyst_do'];
      this['data_wyst_od'] = data['data_wyst_od'];
      this['do_zaplaty'] = data['do_zaplaty'];
      this['dok_sprz_typ_do'] = data['dok_sprz_typ_do'];
      this['dok_sprz_typ_od'] = data['dok_sprz_typ_od'];
      this['kwota'] = data['kwota'];
      this['operator_id_do'] = data['operator_id_do'];
      this['operator_id_od'] = data['operator_id_od'];
      this['sp_zaplaty_od'] = data['sp_zaplaty_od'];
      this['sp_zaplaty_do'] = data['sp_zaplaty_do'];
      this['transakcje'] = data['transakcje'];
      this['zaliczka'] = data['zaliczka'];
    }
  }
}

export class RaportUtargJakiSpZaplatySpZaplaty {

  _font_kolor: string = '';
  _font_styl: number = 0;
  _tlo_kolor: string = '';
  do_zaplaty: string = '';
  fontKolor: string = '';
  fontStyl: number = 0;
  kolor: number = 0;
  kwota: string = '';
  opis: string = '';
  sp_zaplaty: string = '';
  statystyka_do_zaplaty: string = '';
  statystyka_kwota: string = '';
  statystyka_zaliczka: string = '';
  statystyka_transakcje: string = '';
  tloKolor: string = '';
  transakcje: string = '';
  zaliczka: string = '';

  constructor(data?: any) {
    if (data) {
      this['_font_kolor'] = data['_font_kolor'];
      this['_font_styl'] = data['_font_styl'];
      this['_tlo_kolor'] = data['_tlo_kolor'];
      this['do_zaplaty'] = data['do_zaplaty'];
      this['fontKolor'] = data['fontKolor'];
      this['fontStyl'] = data['fontStyl'];
      this['kolor'] = data['kolor'];
      this['kwota'] = data['kwota'];
      this['opis'] = data['opis'];
      this['sp_zaplaty'] = data['sp_zaplaty'];
      this['statystyka_do_zaplaty'] = data['statystyka_do_zaplaty'];
      this['statystyka_kwota'] = data['statystyka_kwota'];
      this['statystyka_zaliczka'] = data['statystyka_zaliczka'];
      this['statystyka_transakcje'] = data['statystyka_transakcje'];
      this['tloKolor'] = data['tloKolor'];
      this['transakcje'] = data['transakcje'];
      this['zaliczka'] = data['zaliczka'];
    }
  }
}

export class ObiectRoomNumer {
  akcjeWykonaj: number = 0;
  dana1: string = '';
  dana2: string = '';
  dana3: string = '';
  danePokaz: number = 0;
  data: string = '';
  fontKolor: string = '';
  id: number = 0;
  iloscM: number = 0;
  iloscR: number = 0;
  iloscW: number = 0;
  iloscX: number = 0;
  krainaId: number = 0;
  obiektId: string = '';
  obszarId: number = 0;
  osX: number = 0;
  osY: number = 0;
  regionId: number = 0;
  rodzPokoi: string = '';
  tloKolor: string = '';
  typ: number = 0;
  fontBold: number = 0;
  goscNazwisko: string = '';
  opcja01: number = 0;
  opcja10: number = 0;
  opcja15: number = 0;
  pobytId: number = 0;
  pobytStart: number = 0;
  pobytStop: number = 0;
  pokoj: number = 0;
  statusId: number = 0;
  tagKanal0407: number = 0;


  constructor(data?: any) {
    if (data) {
      this.akcjeWykonaj = data.akcjeWykonaj;
      this.dana1 = data.dana1;
      this.dana2 = data.dana2;
      this.dana3 = data.dana3;
      this.danePokaz = data.danePokaz;
      this.data = data.data;
      this.fontKolor = data.fontKolor;
      this.id = data.id;
      this.iloscM = data.iloscM;
      this.iloscR = data.iloscR;
      this.iloscW = data.iloscW;
      this.iloscX = data.iloscX;
      this.krainaId = data.krainaId;
      this.obiektId = data.obiektId;
      this.obszarId = data.obszarId;
      this.osX = data.osX;
      this.osY = data.osY;
      this.regionId = data.regionId;
      this.rodzPokoi = data.rodzPokoi;
      this.tloKolor = data.tloKolor;
      this.typ = data.typ;
      this.fontBold = data.fontBold;
      this.goscNazwisko = data.goscNazwisko;
      this.opcja01 = data.opcja01;
      this.opcja10 = data.opcja10;
      this.opcja15 = data.opcja15;
      this.pobytId = data.pobytId;
      this.pobytStart = data.pobytStart;
      this.pobytStop = data.pobytStop;
      this.pokoj = data.pokoj;
      this.statusId = data.statusId;
      this.tagKanal0407 = data.tagKanal0407;
    }
  }
}

export class ObiectRoomRodzaj {
  akcjeWykonaj: number = 0;
  dana1: string = '';
  dana2: string = '';
  dana3: string = '';
  danePokaz: number = 0;
  data: string = '';
  fontKolor: string = '';
  id: number = 0;
  iloscM: number = 0;
  iloscR: number = 0;
  iloscW: number = 0;
  iloscX: number = 0;
  krainaId: number = 0;
  obiektId: string = '';
  obszarId: number = 0;
  osX: number = 0;
  osY: number = 0;
  regionId: number = 0;
  rodzPokoi: string = '';
  tloKolor: string = '';
  typ: number = 0;
  fontBold: number = 0;

  constructor(data?: any) {
    if (data) {
      this.akcjeWykonaj = data.akcjeWykonaj;
      this.dana1 = data.dana1;
      this.dana2 = data.dana2;
      this.dana3 = data.dana3;
      this.danePokaz = data.danePokaz;
      this.data = data.data;
      this.fontKolor = data.fontKolor;
      this.id = data.id;
      this.iloscM = data.iloscM;
      this.iloscR = data.iloscR;
      this.iloscW = data.iloscW;
      this.iloscX = data.iloscX;
      this.krainaId = data.krainaId;
      this.obiektId = data.obiektId;
      this.obszarId = data.obszarId;
      this.osX = data.osX;
      this.osY = data.osY;
      this.regionId = data.regionId;
      this.rodzPokoi = data.rodzPokoi;
      this.tloKolor = data.tloKolor;
      this.typ = data.typ;
      this.fontBold = data.fontBold;
    }
  }
}

export class RodzPokoiInfo {
  id: string = '';
  rodzPokoi: string = '';
  opis: string = '';
  iloscMiejsc: string = '';
  ktoraCena: string = '';
  ktoraCenaOpis: string = '';
  cena: string = '';
  foto: string = '';
  info: string = '';
  minIloscDni: string = '';
  minIloscOsob: string = '';
  wolneNoclegi: string = '';
  rodzNoclegu: string = '';

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.rodzPokoi = data.rodzPokoi;
      this.opis = data.opis;
      this.iloscMiejsc = data.iloscMiejsc;
      this.ktoraCena = data.ktoraCena;
      this.ktoraCenaOpis = data.ktoraCenaOpis;
      this.cena = data.cena;
      this.foto = data.foto;
      this.info = data.info;
      this.minIloscDni = data.minIloscDni;
      this.minIloscOsob = data.minIloscOsob;
      this.wolneNoclegi = data.wolneNoclegi;
      this.rodzNoclegu = data.rodzNoclegu;
    }
  }
}

export class PokojeDostepne {
  cena: string = '';
  iloscMiejsc: string = '';
  ktoraCena: string = '';
  ktoraCenaOpis: string = '';
  opis: string = '';
  pokoj: string = '';

  constructor(data?: any) {
    if (data) {
      this.cena = data.cena;
      this.iloscMiejsc = data.iloscMiejsc;
      this.ktoraCena = data.ktoraCena;
      this.ktoraCenaOpis = data.ktoraCenaOpis;
      this.opis = data.opis;
      this.pokoj = data.pokoj;
    }
  }
}

export class WwwPortalInfo0 {
  opis: string = '';
  domena: string = '';
  kontakt_e_mail: string = '';
  kontakt_telefon: string = '';
  kontakt_fax: string = '';
  kontakt_adres: string = '';
  kontakt_gps: string = '';
  info: string = '';
  google_maps: string = '';
  materialui_zestaw_nr: string = '';
  pay_web: string = '';

  constructor(data?: any) {
    if (data) {
      this.opis = data.opis;
      this.domena = data.domena;
      this.kontakt_e_mail = data.kontakt_e_mail;
      this.kontakt_telefon = data.kontakt_telefon;
      this.kontakt_fax = data.kontakt_fax;
      this.kontakt_adres = data.kontakt_adres;
      this.kontakt_gps = data.kontakt_gps;
      this.info = data.info;
      this.google_maps = data.google_maps;
      this.materialui_zestaw_nr = data.materialui_zestaw_nr;
      this.pay_web = data.pay_web;
    }
  }
}

export class Gosc {
  gosc_id: string = '';
  nazwisko: string = '';
  telefon: string = '';
  e_mail: string = '';

  constructor(data?: any) {
    if (data) {
      this.gosc_id = data.gosc_id;
      this.nazwisko = data.nazwisko;
      this.telefon = data.telefon;
      this.e_mail = data.e_mail;
    }
  }
}

// Generated by https://quicktype.io

export class UserInfo {
  id: string = '';
  email: string = '';
  verified_email: boolean = false;
  name: string = '';
  given_name: string = '';
  family_name: string = '';
  picture: string = '';
  locale: string = '';

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.email = data.email;
      this.verified_email = data.verified_email;
      this.name = data.name;
      this.given_name = data.given_name;
      this.family_name = data.family_name;
      this.picture = data.picture;
      this.locale = data.locale;
    }
  }
}

// Generated by https://quicktype.io

export interface Me {
  id:         string;
  name:       string;
  first_name: string;
  last_name:  string;
  email:      string;
  picture:    Picture;
}

export interface Picture {
  data: Data;
}

export interface Data {
  height:        number;
  is_silhouette: boolean;
  url:           string;
  width:         number;
}

export class VatHeder {

  adres: string = '';
  algVat: string = '';
  brutto: string = '';
  dataSprz: string = '';
  dataWyst: string = '';
  doZaplaty: string = '';
  dokNr: string = '';
  //dokSprzedazyOpis: string = '';
  dokTypNrWydruk: string = '';
  infoF: string = '';
  kontrId: string = '';
  kontrNazwa: string = '';
  ksefVscWysylamyDoKsef: string = '';
  lookUpDokTypNrWydrukOpis: string = '';
  lookUpOperatorOpis: string = '';
  lookUpSpZaplatyOpis: string = '';
  netto: string = '';
  nip: string = '';
  operatorId: string = '';
  osobaOdb: string = '';
  pobytDo: string = '';
  pobytOd: string = '';
  pokoj: string = '';
  przydzial: string = '';
  spZaplaty: string = '';
  spZaplatyOpis: string = '';
  sprzedazOdroczona: string = '';
  terminDt: string = '';
  vat: string = '';
  zaliczka: string = '';
  zamkniety: string = '';

  constructor(data?: any) {
    if (data) {
      this.adres = data.adres;
      this.algVat = data.algVat;
      this.brutto = data.brutto;
      this.dataSprz = data.dataSprz;
      this.dataWyst = data.dataWyst;
      this.doZaplaty = data.doZaplaty;
      this.dokNr = data.dokNr;
      //this.dokSprzedazyOpis = data.dokSprzedazyOpis;
      this.dokTypNrWydruk = data.dokTypNrWydruk;
      this.infoF = data.infoF;
      this.kontrId = data.kontrId;
      this.kontrNazwa = data.kontrNazwa;
      this.ksefVscWysylamyDoKsef = data.ksefVscWysylamyDoKsef;
      this.lookUpDokTypNrWydrukOpis = data.lookUpDokTypNrWydrukOpis;
      this.lookUpOperatorOpis = data.lookUpOperatorOpis;
      this.lookUpSpZaplatyOpis = data.lookUpSpZaplatyOpis;
      this.netto = data.netto;
      this.nip = data.nip;
      this.operatorId = data.operatorId;
      this.osobaOdb = data.osobaOdb;
      this.pobytDo = data.pobytDo;
      this.pobytOd = data.pobytOd;
      this.pokoj = data.pokoj;
      this.przydzial = data.przydzial;
      this.spZaplaty = data.spZaplaty;
      this.spZaplatyOpis = data.spZaplatyOpis;
      this.sprzedazOdroczona = data.sprzedazOdroczona;
      this.terminDt = data.terminDt;
      this.vat = data.vat;
      this.zaliczka = data.zaliczka;
      this.zamkniety = data.zamkniety;
    }
  }
}

export class VatTableVat {
  brutto: string = '';
  dokNr: string = '';
  netto: string = '';
  przydzial: string = '';
  vat: string = '';
  vatStawka: string = '';


  constructor(data?: any) {
    if (data) {
      this.brutto = data.brutto;
      this.dokNr = data.dokNr;
      this.netto = data.netto;
      this.przydzial = data.przydzial;
      this.vat = data.vat;
      this.vatStawka = data.vatStawka;
    }
  }
}

export class VatTableRow {
  asortId: string = '';
  asortNazwa: string = '';
  brutto: string = '';
  cenaBrutto: string = '';
  cenaNetto: string = '';
  dokLp: string = '';
  dokNr: string = '';
  ilosc: string = '';
  jm: string = '';
  netto: string = '';
  przydzial: string = '';
  vat: string = '';
  vatStawka: string = '';


  constructor(data?: any) {
    if (data) {
      this.asortId = data.asortId;
      this.asortNazwa = data.asortNazwa;
      this.brutto = data.brutto;
      this.cenaBrutto = data.cenaBrutto;
      this.cenaNetto = data.cenaNetto;
      this.dokLp = data.dokLp;
      this.dokNr = data.dokNr;
      this.ilosc = data.ilosc;
      this.jm = data.jm;  
      this.netto = data.netto;
      this.przydzial = data.przydzial;
      this.vat = data.vat;
      this.vatStawka = data.vatStawka;
    }
  }
}

export class VatInstalacja {
  naglLinia1: string = '';
  naglLinia2: string = '';
  naglLinia3: string = '';
  naglLinia4: string = '';
  naglLinia5: string = '';
  przydzial: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.naglLinia1 = data.naglLinia1;
      this.naglLinia2 = data.naglLinia2;
      this.naglLinia3 = data.naglLinia3;
      this.naglLinia4 = data.naglLinia4;
      this.naglLinia5 = data.naglLinia5;
      this.przydzial = data.przydzial;
    }
  }
}

export class VatNotes {
  dokNr: string = '';
  liniaNr: string = '';
  przydzial: string = '';
  tekst: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.dokNr = data.dokNr;
      this.liniaNr = data.liniaNr;
      this.przydzial = data.przydzial;
      this.tekst = data.tekst;
    }
  }
}

export class VatDokNr {
  dokNr: string = '';
  przydzial: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.dokNr = data.dokNr;
      this.przydzial = data.przydzial;
    }
  }
}

export class DaneNIPGus {
  dt: string = '';
  miejscowosc: string = '';
  nazwa: string = '';

  kodPocztowy: string = '';
  nipOdpowiedz: string = '';
  nipPytanie: string = '';
  ulica: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.dt = data.dt;
      this.miejscowosc = data.miejscowosc;
      this.nazwa = data.nazwa;

      this.kodPocztowy = data.kodPocztowy;
      this.nipPytanie = data.nipPytanie;
      this.nipOdpowiedz = data.nipOdpowiedz;
      this.ulica = data.ulica;
    }
  }
}

export class DaneNIPVies {
  dt: string = '';
  miejscowosc: string = '';
  nazwa: string = '';

  aktywny: string = '';
  nip: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.dt = data.dt;
      this.miejscowosc = data.miejscowosc;
      this.nazwa = data.nazwa;

      this.aktywny = data.aktywny;
      this.nip = data.nip;
    }
  }
}

export type Prefiks = {
  prefiks: string,
  opis: string,
  domena: string,
  lbCyfr: string,
}


export class KsefFaktura {
  vscStatus: string = '';
  ksefKsefNumber: string = '';
  ksefStatusCode: string = '';
  ksefFakturaOk: string = '';
  link: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.vscStatus = data.vscStatus;
      this.ksefKsefNumber = data.ksefKsefNumber;
      this.ksefStatusCode = data.ksefStatusCode;
      this.ksefFakturaOk = data.ksefFakturaOk;
      this.link = data.link;
    }
  }
}


export type dajHaslaType = {
  hotelId: string;
  pobytId: string;
  ident_oper: string;
  nazwisko: string;
}

export class HasłoRezerwacja {
  autolockObiektPasscode: string = '';
  autolockParkingPasscode: string = '';
  autolockPietroPasscode: string = '';
  autolockPokojPasscode: string = '';
  autolockObiektAktywny: string = '';
  autolockParkingAktywny: string = '';
  autolockPietroAktywny: string = '';
  autolockPokojAktywny: string = '';
  manuallockObiektAktywny: string = '';
  manuallockParkingAktywny: string = '';
  manuallockParkingPasscode: string = '';
  manuallockPasscode: string = '';
  manuallockPietroAktywny: string = '';
  manuallockPietroPasscode: string = '';
  manuallockPokojAktywny: string = '';
  manuallockPokojPasscode: string = '';
  pobytId: string = '';
  pokoj: string = '';

  constructor(data?: any) {
    if (data) {
      this.autolockObiektPasscode = data.autolockObiektPasscode;
      this.autolockParkingPasscode = data.autolockParkingPasscode;
      this.autolockPietroPasscode = data.autolockPietroPasscode;
      this.autolockPokojPasscode = data.autolockPokojPasscode;
      this.autolockObiektAktywny = data.autolockObiektAktywny;
      this.autolockParkingAktywny = data.autolockParkingAktywny;
      this.autolockPietroAktywny = data.autolockPietroAktywny;
      this.autolockPokojAktywny = data.autolockPokojAktywny;
      this.manuallockObiektAktywny = data.manuallockObiektAktywny;
      this.manuallockParkingAktywny = data.manuallockParkingAktywny;
      this.manuallockParkingPasscode = data.manuallockParkingPasscode;
      this.manuallockPasscode = data.manuallockPasscode;
      this.manuallockPietroAktywny = data.manuallockPietroAktywny;
      this.manuallockPietroPasscode = data.manuallockPietroPasscode;
      this.manuallockPokojAktywny = data.manuallockPokojAktywny;
      this.manuallockPokojPasscode = data.manuallockPokojPasscode;
      this.pobytId = data.pobytId;
      this.pokoj = data.pokoj;
    }
  }
}